import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {

  @ViewChild('modalConfirm', { static: true }) modalConfirm: ModalDirective

  // Input
  @Input() title: String = ""
  @Input() contentText: String = ""
  @Input() acceptButtonText: String = "Aceptar"
  @Input() cancelButtonText: String = "Cancelar"

  // Output
  @Output() onAccept: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();

  loading = false;
  // Callbacks
  private acceptCallback: Function;
  private cancelCallback: Function;
  processing: boolean = false

  constructor() { }

  ngOnInit() {
  }

  /********* SHOW/HIDE *********/
  show(acceptCallback: Function = null, cancelCallback: Function = null) {
    this.acceptCallback = acceptCallback
    this.cancelCallback = cancelCallback
    this.modalConfirm.show();
  }

  showWithInlineConfig(title: string, contentText: string, acceptCallback: Function = null, cancelCallback: Function = null) {
    this.title = title
    this.contentText = contentText
    this.acceptCallback = acceptCallback
    this.cancelCallback = cancelCallback
    this.modalConfirm.show();
  }

  hide() {
    this.modalConfirm.hide();
    return new Promise(resolve => {
      setTimeout(() => {

        this.processing = false;
      }, 1000);
    });
    //this.processing = false

  }
  /********* SHOW/HIDE *********/

  /********* OPERATIONS *********/
  async accept() {
    this.processing = true
    if (this.acceptCallback) {

      this.acceptCallback()
    }
    console.log("Carga")
    this.onAccept.emit();
    await this.hide();
  }

  cancel() {
    if (this.cancelCallback)
      this.cancelCallback()
    this.onCancel.emit();
    this.hide()
  }
  /********* OPERATIONS *********/

}
